import React from "react";
import { colors, typography, btnSecondary } from "../utils/designTokens";

/**
 * Pill compacto del header (Tu día, Clima, Alertas, etc.). Sustituye los
 * `styles.pillBtn` que cada pantalla reinventaba con padding/colors propios.
 *
 * Props:
 *  - icon: nodo React opcional (FaIcon, emoji span, etc.).
 *  - label: texto principal.
 *  - badge: nodo opcional renderizado a la derecha (count, score, etc.).
 *  - onClick.
 *  - title: tooltip nativo.
 *  - ariaLabel.
 *  - active: estilo destacado si el contenido es relevante (default false).
 */
export default function PillButton({
  icon,
  label,
  badge,
  onClick,
  title,
  ariaLabel,
  active = false,
  disabled = false,
}) {
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      aria-label={ariaLabel || title || label}
      title={title}
      style={{
        ...btnSecondary,
        padding: "6px 12px",
        fontSize: typography.sizes.sm,
        display: "inline-flex",
        alignItems: "center",
        gap: 6,
        cursor: disabled ? "not-allowed" : "pointer",
        opacity: disabled ? 0.55 : 1,
        background: active ? colors.primaryLighter : undefined,
        borderColor: active ? colors.primary : undefined,
      }}
    >
      {icon && <span style={{ display: "inline-flex", alignItems: "center" }}>{icon}</span>}
      <span>{label}</span>
      {badge != null && badge !== false && (
        <span style={{ display: "inline-flex", alignItems: "center" }}>{badge}</span>
      )}
    </button>
  );
}
